import type { SVGProps } from 'react';

export const MastercardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#243747"
      d="M2 3h20a2 2 0 0 1 2 2v13.74a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"
    />
    <path
      fill="#E61C24"
      d="M9.392 16.044a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348Z"
    />
    <path
      fill="#F99F1B"
      d="M14.574 16.044a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348Z"
    />
    <path
      fill="#F26622"
      fillRule="evenodd"
      d="M11.983 8.601a4.166 4.166 0 0 0 0 6.537 4.166 4.166 0 0 0 0-6.537Z"
      clipRule="evenodd"
    />
  </svg>
);
